module.exports = __webpack_public_path__ + "img/IMG_9432_L_Wood.935b9a2c.jpg";